<template>
		<v-row no-gutters class="mt-4">
			<v-col cols="12" md="6" offset-md="3" class="justify-center">	
				<div class="banner">
					<a href="http://www.regione.toscana.it/creo" target="_blank">
						<v-img src="@/assets/img/blocco-loghi-porcreo.png"></v-img>
					</a>
				</div>
			</v-col>
		</v-row>
</template>
<script>
export default {
}
</script>